import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Icon, ErrorBoundary } from 'components'
import { getPlanParams } from 'store/selectors'
import { toggleMobileMenu } from 'store/actions'

class Header extends React.Component {
  render() {
    return (
      <header className={this.props.isProgress ? 'progress' : ''}>
        <ErrorBoundary>
          <div className="menu-button" onClick={this.props.toggleMobileMenu}>
            {this.props.menuOpen ? <Icon name="exit" /> : <Icon name="menu" />}
          </div>
          <h4 className="brand-mobile" onClick={this.props.toggleMobileMenu}>
            {this.props.menuOpen ? 'View Summary' : 'Edit Goals'}
          </h4>
          <h4 className="brand-desktop">
            Capitalmind <strong>Wealth</strong>
          </h4>
          <div className="header-nav">
            {!this.props.isProgress && (
              <nav>
                <a href="https://plan.capitalmindwealth.com" className="active">
                  Plan
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.capitalmindwealth.com/"
                >
                  Invest
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.capitalmindwealth.com/faqs/"
                >
                  FAQs
                </a>
                <Link to="/templates">Sample Plans</Link>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.youtube.com/watch?v=UqVVl4XFUR4"
                >
                  Video Tutorial
                </a>
              </nav>
            )}
          </div>
          {this.props.isProgress ? (
            <button
              onClick={() => this.props.history.replace('/save-draft')}
              disabled={Object.keys(this.props.planParams.goals).length === 0}
            >
              Update
            </button>
          ) : (
            <button
              onClick={() => this.props.history.replace('/email')}
              disabled={Object.keys(this.props.planParams.goals).length === 0}
            >
              <Icon name="share-white" small />
              Share
            </button>
          )}
        </ErrorBoundary>
      </header>
    )
  }
}

export default connect(
  state => ({
    planParams: getPlanParams(state),
    menuOpen: state.display.menuOpen,
  }),
  { toggleMobileMenu }
)(Header)



// WEBPACK FOOTER //
// ./src/components/layout/Header.js